import React, { useState } from "react";
import * as Mui from "@mui/material";
import { Info } from "@mui/icons-material";
import { customAPI } from "services/utils/CustomAPI";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useFetch } from "services/hooks/useFetch";
import { formKeyText } from "services/constants/Styles";
import { CustomButton } from "components/CustomComponents";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { CustomAutoComplete } from "components/CustomComponents";
import { themes } from "services/constants";
import { showToast } from "services/utils/Status";
import { tooltipStyleProps } from "services/constants/Styles";
export const IndividualLeaveGroupMove = ({
  individualPersonMove,
  setIndividualPersonMove,
  individualPersonMoveDetails,
  setFetchUserDetails,
}) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  const [leaveGroupName, setLeaveGroupName] = useState("");
  const [leaveGroupId, setLeaveGroupId] = useState(0);
  const { result: leaveGroupArray } = useFetch(`${domain}leave-group-new/`);
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  const moveGroup = async (data) => {
    let payload = {
      user_id: [individualPersonMoveDetails?.user_id],
      target_leavegroup_id: leaveGroupId,
      effective_from: data?.effective_from,
    };
    const response = await customAPI(
      `${domain}moveleavegroup-assignment/`,
      "PUT",
      payload
    );
    if (response.ok) {
      showToast(
        "success",
        "The user has successfully joined the new leave group."
      );
      setIndividualPersonMove(false);
      setFetchUserDetails(true);
      reset();
    }
  };

  const handleLeaveGroupName = (event, data) => {
    if (data) {
      setLeaveGroupId(data?.id);
      setLeaveGroupName(data?.label);
      setValue("leave_group_name", data?.label);
    }
  };

  return (
    <React.Fragment>
      <GlobalDialogBox
        open={individualPersonMove}
        handleCloseDialog={() => {
          setIndividualPersonMove(false);
        }}
        title={"Move"}
        minWidth={700}
        minHeight={300}
      >
        <form onSubmit={handleSubmit(moveGroup)}>
          <Mui.Grid
            container
            sx={{
              borderRadius: 2,
              border: `2px solid ${themes.sidebarDivider}`,
              backgroundColor: themes.primary,
              padding: 1,
            }}
          >
            <Mui.Grid container>
              <Mui.Grid container xs={2}>
                <Mui.Grid xs={6}>Id </Mui.Grid>
                <Mui.Grid xs={6}>{individualPersonMoveDetails?.id}</Mui.Grid>
              </Mui.Grid>

              <Mui.Grid xs={5}>
                <Mui.Grid container>
                  <Mui.Grid xs={6}>
                    <Mui.Typography>Name</Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={6}>
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={individualPersonMoveDetails.user_name}
                    >
                      {individualPersonMoveDetails.user_name
                        ? individualPersonMoveDetails.user_name.length >= 15
                          ? individualPersonMoveDetails.user_name.substr(
                              0,
                              15
                            ) + "..."
                          : individualPersonMoveDetails.user_name
                        : "N/A"}
                    </Mui.Tooltip>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container xs={5}>
                <Mui.Grid xs={6}>Leave Group</Mui.Grid>
                <Mui.Grid xs={6}>
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title={individualPersonMoveDetails.leave_group_name}
                  >
                    {individualPersonMoveDetails.leave_group_name
                      ? individualPersonMoveDetails.leave_group_name.length >=
                        15
                        ? individualPersonMoveDetails.leave_group_name.substr(
                            0,
                            15
                          ) + "..."
                        : individualPersonMoveDetails.leave_group_name
                      : "N/A"}
                  </Mui.Tooltip>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid container xs={2}>
                <Mui.Grid xs={6}>Count</Mui.Grid>
                <Mui.Grid xs={6}>
                  {individualPersonMoveDetails?.leave_type_count?.length}
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid xs={5}>
                <Mui.Grid container>
                  <Mui.Grid xs={6}>
                    <Mui.Typography>Effective From</Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={6}>
                    {individualPersonMoveDetails.effective_from}
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ paddingTop: 1 }}>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                New Leave Group &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Select the new leave group to which the 
                  will be reassigned. This will update their leave entitlements and policies accordingly."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6}>
              <CustomAutoComplete
                dataList={leaveGroupArray
                  .filter(
                    (obj) =>
                      obj?.name !== individualPersonMoveDetails.leave_group_name
                  )
                  .map((obj) => ({
                    ...obj,
                    label: obj?.name,
                  }))}
                rules={{
                  ...register("leave_group_name", {
                    required: "Leave Group name is required",
                  }),
                }}
                selectedValue={leaveGroupName}
                updateDataFunction={handleLeaveGroupName}
                placeHolder="Select the leave Group"
                errorMessage={
                  errors?.leave_group_name?.message
                    ? errors?.leave_group_name?.message
                    : ""
                }
                textBoxError={errors.leave_group_name ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ paddingTop: 1 }}>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                Effective From &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Specify the date from which the new leave group assignment will take effect."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6}>
              <Mui.TextField
                id="from-date"
                type="date"
                size="small"
                {...register("effective_from", {
                  required: "Effect from date is required.",
                })}
                error={Boolean(errors.effective_from)}
                helperText={errors.effective_from?.message}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: new Date().toISOString().split("T")[0],
                }}
                fullWidth
                disableOpenPicker
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid
            container
            spacing={2}
            sx={{ justifyContent: "flex-end", paddingTop: 5 }}
          >
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => {
                  setIndividualPersonMove(false);
                }}
                actionName="Cancel"
                typeName="submit"
              />
            </Mui.Grid>
            <Mui.Grid item>
              <CustomButton actionName="Move" typeName="submit" />
            </Mui.Grid>
          </Mui.Grid>
        </form>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
